'use client';

import React from 'react';
import { DropdownContainer, Divider, DropdownContent, List, ListItem, NoResultsListItem, PredictiveTextSubText } from './elements';
import { PredictedHeader } from './PredictedHeader';
import { StateLayer } from '../../core-components';
export const PredictiveDropdown = ({
  listId,
  'data-testid': dataTestId,
  keyword,
  onSelection,
  setFocused,
  suggestions,
  includeSubheader,
  alertNoResults,
  fieldStatus,
  activeSuggestionIndex,
  setActiveSuggestionIndex,
  noResultsText,
  ariaLabelledby,
  maxHeight,
  dropdownListItemClassName
}) => /*#__PURE__*/React.createElement(DropdownContainer, {
  "data-testid": dataTestId
}, /*#__PURE__*/React.createElement(DropdownContent, {
  fieldStatus: fieldStatus
}, alertNoResults && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(List, {
  role: "listbox",
  id: listId,
  "aria-labelledby": ariaLabelledby,
  maxHeight: maxHeight
}, suggestions.length > 0 ? suggestions.map((suggestion, index) => /*#__PURE__*/React.createElement(ListItem, {
  role: "option",
  $subHeader: includeSubheader,
  "aria-selected": activeSuggestionIndex === index,
  className: dropdownListItemClassName,
  isSelected: activeSuggestionIndex === index,
  key: suggestion.id,
  id: suggestion.id,
  onMouseDown: event => {
    event.preventDefault();
  },
  onClick: () => {
    setFocused(false);
    onSelection && onSelection(suggestion);
  },
  onMouseEnter: () => setActiveSuggestionIndex(index)
}, /*#__PURE__*/React.createElement(StateLayer, null), /*#__PURE__*/React.createElement(PredictedHeader, {
  "data-testid": 'predicted-header-highlighted-text',
  queryString: keyword,
  fullString: suggestion.header
}), includeSubheader && /*#__PURE__*/React.createElement(PredictiveTextSubText, null, suggestion.subHeader))) : alertNoResults && /*#__PURE__*/React.createElement(NoResultsListItem, null, noResultsText ?? 'No Results'))));